import * as t from './actionTypes';

const initialState = { isLoading: false, locations: [] };

const locationReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.LOCATION_LOAD_SUCCESS:
            var locations = action.locations;
            var locationArr = [];

            for (var location in locations) {
                locationArr.push(locations[location]);
            }

            return Object.assign({}, state, { locations: locationArr });

        default:
            return state;
    }
};

export default locationReducer;
